import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileHandlerComponent } from '../components/file-upload/file-handler.component';
import { ReportSelfInspectionWrapperComponent } from '../components/report-self-inspection-wrapper/report-self-inspection-wrapper.component';
import { TextInputComponent } from '../components/text-input/text-input.component';
import {
  FileAndTextInputData,
  SelfInspcetionWrapperData,
} from '../report-input-entities';
import { SelfInspectionBaseClassComponent } from '../self-inspection-base-class/self-inspection-base-class.component';

@Component({
  selector: 'app-self-inspection-file-and-text',
  imports: [
    ReportSelfInspectionWrapperComponent,
    FileHandlerComponent,
    TextInputComponent,
  ],
  templateUrl: './self-inspection-file-and-text.component.html',
  styleUrl: './self-inspection-file-and-text.component.scss',
})
export class SelfInspectionFileAndTextComponent<
  T,
> extends SelfInspectionBaseClassComponent<T> {
  @Input() data: FileAndTextInputData;
  @Input() wrapperData: SelfInspcetionWrapperData;

  @Output() viewImages = new EventEmitter();
  @Output() filesDownload = new EventEmitter<
    {
      fileName: string;
      fileId: string;
    }[]
  >();
  @Output() fileDelete = new EventEmitter<string>();
  @Output() markAsNA = new EventEmitter();
  @Output() undoSelfInspection = new EventEmitter();
  @Output() saveTextInput = new EventEmitter<T>();

  showWarning = false;

  get selfInspectionId(): string {
    return this.data.textData.id;
  }

  saveInput(input: string) {
    this.setIsLoadingTrue();
    this.saveTextInput.emit({ fileAndText: input } as T);
  }

  handleHasUnsavedChanges(event: boolean) {
    this.showWarning = event;
  }
}
